export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;

export const MIN_ROWS_PER_PAGE = Math.min(...ROWS_PER_PAGE_OPTIONS);
